import React from "react";
import { MoreVertical } from "lucide-react";
import "../../components/DashboardModule/MyQuotations.css";
import { LuSearch } from "react-icons/lu";

const RA = () => {
  return (
    <div className="quo-container font-poppins">
      <div className="quo-header">
        <h2 className="quo-title">Reverse Auction(RA)</h2>
        <div className="quo-actions">
          <div className="quo-search-container">
            <LuSearch className="quo-search-icon" />
            <input
              type="text"
              placeholder="Search quotations"
              className="quo-search font-poppins"
            />
          </div>
        </div>
      </div>
      
      <table className="quo-table">
        <thead>
          <tr>
            <th>Enquiry No.</th>
            <th>Brand Name</th>
            <th>Specification</th>
            <th>Date</th>
            <th>Bid</th>
            <th>RA Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {/* <tr>
            <td><input type="checkbox" /> 00123</td>
            <td>Indian Expo Steels Pvt</td>
            <td>
              <ul>
                <li>Dimensions (6x5)</li>
                <li>Qty (50 pc)</li>
              </ul>
            </td>
            <td>10/08/2023</td>
            <td>Rs 500</td>
            <td className="quo-highlight">Tata Steel <br />Rs 49,00,000</td>

            <td>
              <div className="quo-action-menu">
                <MoreVertical />
                <div className="quo-dropdown">
                  <button className="text-quo font-poppins" >Preview</button>
                  <button className="text-quo font-poppins">Add comment</button>
                  <button className="text-quo font-poppins">Download</button>
                  <button className="text-quo font-poppins"> Cancel</button>
                </div>
              </div>
            </td>
          </tr> */}
        </tbody>
      </table>

      {/* <div className="quo-summary">
        <table className="quo-summary-table">
          <thead>
            <tr>
              <th>Enquiry No.</th>
              <th>Brand Name</th>
              <th>Specification</th>
              <th>Date</th>
              <th>Bid</th>
              <th>RA Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>00123</td>
              <td>Indian Expo Steels Pvt</td>
              <td>
                <ul>
                  <li>Dimensions (6x5)</li>
                  <li>Qty (50 pc)</li>
                </ul>
              </td>
              <td>10/08/2023</td>
              <td>Rs 500000</td>
              <td className="quo-highlight">Tata Steel <br />Rs 49,00,000</td>
              <td>
                <div className="quo-action-menu">
                  <MoreVertical />
                  <div className="quo-dropdown ">
                    <button className="text-quo font-poppins">Preview</button>
                    <button className="text-quo font-poppins">Add comment</button>
                    <button className="text-quo font-poppins">Download</button>
                    <button className="text-quo font-poppins">Cancel</button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div> */}

      {/* <div className="quo-bottom-actions ">
        <button className="quo-accept font-poppins">ACCEPT</button>
        <button className="quo-add-comment font-poppins">ADD COMMENT</button>
      </div> */}
    </div>
  );
};

export default RA;